import { render, staticRenderFns } from "./event-feed-set.vue?vue&type=template&id=1e5a56ba&"
import script from "./event-feed-set.vue?vue&type=script&lang=js&"
export * from "./event-feed-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5a56ba')) {
      api.createRecord('1e5a56ba', component.options)
    } else {
      api.reload('1e5a56ba', component.options)
    }
    module.hot.accept("./event-feed-set.vue?vue&type=template&id=1e5a56ba&", function () {
      api.rerender('1e5a56ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/event-listing/components/event-feed-set.vue"
export default component.exports